/**
 * Shared API configuration constants.
 * Extracted to a neutral module to avoid circular imports between
 * api.ts and MaintenanceContext.tsx.
 */
export const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL || 'http://localhost:5000';
